const REDIRECT = '/redirect';
const TOKEN = '/token';
const REFRESH = '/refresh';

export {
  REDIRECT,
  TOKEN,
  REFRESH,
};
